(function () {
  function init(root = document) {
    root.querySelectorAll('[data-brv-card-swipe]').forEach(setup);
  }

  function setup(overlay) {
    if (overlay.__brv) return;
    overlay.__brv = true;

    const wrapper = overlay.closest('.product-card__image-wrapper');
    const img = wrapper && wrapper.querySelector('.product-card__image--main img');
    const dotsC = wrapper && wrapper.querySelector('.brv-dots');
    let images = [];

    try { images = JSON.parse(overlay.getAttribute('data-images') || '[]'); }
    catch (e) { images = []; }

    if (!img || !images || images.length < 2) {
      overlay.remove();
      if (dotsC) dotsC.remove();
      return;
    }

    if (dotsC) {
      dotsC.innerHTML = images.map((_, k) => `<span class="${k === 0 ? 'is-active' : ''}"></span>`).join('');
    }

    let idx = 0;
    function setImage(n) {
      idx = (n + images.length) % images.length;
      const url = images[idx];
      img.src = url;
      if (img.srcset) img.srcset = `${url} 1200w`;
      if (dotsC) dotsC.querySelectorAll('span').forEach((s, i) => s.classList.toggle('is-active', i === idx));
    }

    // UMBRALES MÁS ESTRICTOS
    const SWIPE_THRESHOLD = 24;     // px horizontales para cambiar imagen
    const H_DOMINANCE = 1.05;       // el movimiento X debe ser 1.25x el Y
    const VERT_TOLERANCE = 12;      // si Y supera esto, lo tratamos como scroll
    const TAP_MOVE_MAX = 6;         // movimiento máx para considerarlo tap
    const TAP_TIME_MAX = 250;       // ms máx para tap

    let startX = 0, startY = 0, deltaX = 0, deltaY = 0;
    let swiping = false, verticalScroll = false, startTime = 0;

    overlay.addEventListener('touchstart', (e) => {
      if (e.touches.length !== 1) return;
      const t = e.touches[0];
      startX = t.clientX;
      startY = t.clientY;
      deltaX = 0;
      deltaY = 0;
      verticalScroll = false;
      swiping = true;
      startTime = Date.now();
    }, { passive: true });

    overlay.addEventListener('touchmove', (e) => {
      if (!swiping) return;
      const t = e.touches[0];
      deltaX = t.clientX - startX;
      deltaY = t.clientY - startY;

      // Si hay desplazamiento vertical claro, marcamos scroll y luego ignoramos
      if (Math.abs(deltaY) > VERT_TOLERANCE && Math.abs(deltaY) > Math.abs(deltaX)) {
        verticalScroll = true;
      }
    }, { passive: true });

    function end() {
      if (!swiping) return;
      swiping = false;

      // 1) Si fue scroll vertical, no hagas nada
      if (verticalScroll) return;

      const absX = Math.abs(deltaX);
      const absY = Math.abs(deltaY);

      // 2) Swipe: X grande y domina a Y
      if (absX > SWIPE_THRESHOLD && absX > absY * H_DOMINANCE) {
        setImage(idx + (deltaX < 0 ? 1 : -1));
        return;
      }

      // 3) Tap “real”: casi sin movimiento y rápido
      const duration = Date.now() - startTime;
      if (absX <= TAP_MOVE_MAX && absY <= TAP_MOVE_MAX && duration <= TAP_TIME_MAX) {
        const link = overlay.closest('.product-card')?.querySelector('a.full-width-link');
        if (link) link.click();
      }
      // Si no fue ni swipe ni tap claro, no hacemos nada (evita falsos clics)
    }

    overlay.addEventListener('touchend', end, { passive: true });
    overlay.addEventListener('touchcancel', () => { swiping = false; verticalScroll = false; }, { passive: true });
  }

  document.addEventListener('DOMContentLoaded', () => init(document));
  document.addEventListener('shopify:section:load', (e) => init(e.target));
})();
